import { defineMessages } from 'react-intl';
const ID_PREFIX = 'WacSignupForm.Devops.';
export const messages = defineMessages({
  logo: {
    id: `${ID_PREFIX}logo`,
    defaultMessage: 'Atlassian'
  },
  openDevOps: {
    id: `${ID_PREFIX}openDevOps`,
    defaultMessage: 'Open DevOps'
  },
  devopsLogoSubheader: {
    id: `${ID_PREFIX}devopsLogoSubheader`,
    defaultMessage:
      'Connected out-of-the-box and easily extendable to your favorite third-party tools. Powered by Jira Software, the #1 tool used by agile teams.'
  },
  devopsSwitchAccounts: {
    id: `${ID_PREFIX}devopsSwitchAccounts`,
    defaultMessage: 'Log in to another account'
  },
  devopsRecaptcha: {
    id: `${ID_PREFIX}devopsRecaptcha`,
    defaultMessage:
      'This page is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.'
  },
  devopsEula: {
    id: `${ID_PREFIX}devopsEula`,
    defaultMessage:
      "<p>By signing up, you agree to the Atlassian <a href='https://www.atlassian.com/legal/cloud-terms-of-service'>Cloud Terms of Service</a> and <a href='https://www.atlassian.com/legal/privacy-policy'>Privacy Policy.</a></p>"
  },
  noCard: {
    id: `${ID_PREFIX}noCard`,
    defaultMessage: 'No Credit Card Required'
  },
  welcomeMessageLoggedOut: {
    id: `${ID_PREFIX}welcomeMessageLoggedOut`,
    defaultMessage: 'Create your account'
  },
  submitButtonLoggedOut: {
    id: `${ID_PREFIX}submitButtonLoggedOut`,
    defaultMessage: 'Sign up'
  },
  submitButtonLoggedIn: {
    id: `${ID_PREFIX}submitButtonLoggedIn`,
    defaultMessage: 'Sign up'
  },
  inputLabelEmail: {
    id: `${ID_PREFIX}inputLabelEmail`,
    defaultMessage: 'Work email'
  },
  inputLabelPassword: {
    id: `${ID_PREFIX}inputLabelPassword`,
    defaultMessage: 'Password'
  },
  inputLabelFullName: {
    id: `${ID_PREFIX}inputLabelFullName`,
    defaultMessage: 'Full name'
  },
  inputLabelSitenameNew: {
    id: `${ID_PREFIX}inputLabelSitenameNew`,
    defaultMessage: 'Name your suite'
  },
  inputLabelSitenameExisting: {
    id: `${ID_PREFIX}inputLabelSitenameExisting`,
    defaultMessage: 'Select a site (or type a name to create a new one)'
  },
  inputLabelWorkspaceExisting: {
    id: `${ID_PREFIX}inputLabelWorkspaceExisting`,
    defaultMessage: 'Select a workspace (or type a name to create a new one)'
  },
  inputDescriptionSitenameNew: {
    id: `${ID_PREFIX}inputDescriptionSitenameNew`,
    defaultMessage: '* We’ll use this to name your suite and workspaces'
  },
  inputDescriptionSitenameExisting: {
    id: `${ID_PREFIX}inputDescriptionSitenameExisting`,
    defaultMessage: 'The address your team will use to access Jira Software'
  },
  inputToggleSitenameNew: {
    id: `${ID_PREFIX}inputToggleSitenameNew`,
    defaultMessage: 'Start a new site'
  },
  inputToggleSitenameExisting: {
    id: `${ID_PREFIX}inputToggleSitenameExisting`,
    defaultMessage: 'Use an existing site'
  },
  inputSitenameExistingPlaceholder: {
    id: `${ID_PREFIX}inputSitenameExistingPlaceholder`,
    defaultMessage: 'Select or create a new site'
  },
  errorPasswordMinMsg: {
    id: `${ID_PREFIX}errorPasswordMinMsg`,
    defaultMessage: 'Password must be at least 8 characters long'
  },
  passwordStrength: {
    id: `${ID_PREFIX}passwordStrength`,
    defaultMessage: `Password strength:`
  },
  passwordWeak: {
    id: `${ID_PREFIX}passwordWeak`,
    defaultMessage: `Weak`
  },
  passwordModerate: {
    id: `${ID_PREFIX}passwordModerate`,
    defaultMessage: `Moderate`
  },
  passwordStrong: {
    id: `${ID_PREFIX}passwordStrong`,
    defaultMessage: `Strong`
  },
  passwordVeryStrong: {
    id: `${ID_PREFIX}passwordVeryStrong`,
    defaultMessage: `Very strong`
  },
  errorName: {
    id: `${ID_PREFIX}errorName`,
    defaultMessage: 'Invalid name pattern.'
  },
  errorEmailInvalid: {
    id: `${ID_PREFIX}errorEmailInvalid`,
    defaultMessage: 'Please enter a valid email address'
  },
  errorEmailInUse: {
    id: `${ID_PREFIX}errorEmailInUse`,
    defaultMessage: `Oops, an Atlassian account with this email already exists. If you are the owner of this account, please <a href='{signInAccountUrl}'>login to continue</a>.`
  },
  errorSsoInUse: {
    id: `${ID_PREFIX}errorSsoInUse`,
    defaultMessage: `You must use single sign-on to access your account and continue signing up for your product. <a href='{signInAccountUrl}'>Login to continue.</a>`
  },
  errorSitenameUnavailable: {
    id: `${ID_PREFIX}errorSitenameUnavailable`,
    defaultMessage: 'This suite is already taken.'
  },
  errorSitenameInvalid: {
    id: `${ID_PREFIX}errorSitenameInvalid`,
    defaultMessage:
      'Your suite name must be 3 or more lowercase letters and/or numbers. Hyphens are ok if they’re in the middle.'
  },
  slideExistingSiteHeader: {
    id: `${ID_PREFIX}slideExistingSiteHeader`,
    defaultMessage: 'Let’s get started'
  },
  slideExistingSiteSubHeader: {
    id: `${ID_PREFIX}slideExistingSiteSubHeader`,
    defaultMessage:
      'Start building your toolchain with our flagship product for free, then upgrade or add more third-party tools later.'
  },
  slideExistingWorkspaceSubHeader: {
    id: `${ID_PREFIX}slideExistingWorkspaceSubHeader`,
    defaultMessage:
      'Integrate Jira, Confluence and Opsgenie with Bitbucket for free, then upgrade  or add more third-party tools later.'
  },
  slideExistingSiteSubHeaderTooltip: {
    id: `${ID_PREFIX}slideExistingSiteSubHeaderTooltip`,
    defaultMessage:
      'If your chosen site does not include Jira software, we’ll add and integrate it with your suite.'
  },
  slideConfirmationHeader: {
    id: `${ID_PREFIX}slideConfirmationHeader`,
    defaultMessage: 'You’re almost there!'
  },
  slideConfirmationSubHeaderText: {
    id: `${ID_PREFIX}slideConfirmationSubHeaderText`,
    defaultMessage: 'Your new products are now connected to your site.'
  },
  slideConfirmationFooterText: {
    id: `${ID_PREFIX}slideConfirmationFooterText`,
    defaultMessage:
      'Next, dive into a project to start exploring Atlassian Open DevOps.'
  },
  slideConfirmationGetStarted: {
    id: `${ID_PREFIX}slideConfirmationGetStarted`,
    defaultMessage: 'Get started in {product}'
  },
  slideProductConfirmationHeader: {
    id: `${ID_PREFIX}slideProductConfirmationHeader`,
    defaultMessage: 'Review your toolchain'
  },
  slideProductConfirmationSubHeader: {
    id: `${ID_PREFIX}slideProductConfirmationSubHeader`,
    defaultMessage:
      'You’ll connect these products to your site. Remember, new products are free!'
  },
  slideProductConfirmationProductsExisting: {
    id: `${ID_PREFIX}slideProductConfirmationProductsExisting`,
    defaultMessage: 'Existing Products'
  },
  slideProductConfirmationProductsNew: {
    id: `${ID_PREFIX}slideProductConfirmationProductsNew`,
    defaultMessage: 'New Products'
  },
  productListJiraSoftwareName: {
    id: `${ID_PREFIX}productListJiraSoftwareName`,
    defaultMessage: 'Jira Software'
  },
  productListJiraSoftwareDescription: {
    id: `${ID_PREFIX}productListJiraSoftwareDescription`,
    defaultMessage: 'Mission control for your entire team'
  },
  productListConfluenceName: {
    id: `${ID_PREFIX}productListConfluenceName`,
    defaultMessage: 'Confluence'
  },
  productListConfluenceDescription: {
    id: `${ID_PREFIX}productListConfluenceDescription`,
    defaultMessage: 'Keep everyone in the loop'
  },
  productListBitbucketName: {
    id: `${ID_PREFIX}productListBitbucketName`,
    defaultMessage: 'Bitbucket'
  },
  productListBitbucketDescription: {
    id: `${ID_PREFIX}productListBitbucketDescription`,
    defaultMessage:
      'Ship quality code as a team <br/>*With Bitbucket, Github, or Gitlab'
  },
  productListOpsgenieName: {
    id: `${ID_PREFIX}productListOpsgenieName`,
    defaultMessage: 'Opsgenie'
  },
  productListOpsgenieDescription: {
    id: `${ID_PREFIX}productListOpsgenieDescription`,
    defaultMessage: 'Streamline incident management'
  },
  devopsEmailSent: {
    id: `${ID_PREFIX}devopsEmailSent`,
    defaultMessage:
      'Click the link sent to <div>{email}</div> to verify your email and activate your account.'
  },
  devopsNoResendNoEmail: {
    id: `${ID_PREFIX}devopsNoResendNoEmail`,
    defaultMessage: "Don't see any email? Check your spam folder."
  },
  devopsHeader: {
    id: `${ID_PREFIX}devopsHeader`,
    defaultMessage: 'Your suite is ready!'
  },
  devopsSubHeader: {
    id: `${ID_PREFIX}devopsSubHeader`,
    defaultMessage: 'Verify your email address'
  },
  marketingConsent: {
    id: `${ID_PREFIX}marketingConsent`,
    defaultMessage: `Yes! I would like to receive promotional emails including product news, events and more from Atlassian and its affiliates.`
  },
  devopsSidebarTextPlan: {
    id: `${ID_PREFIX}devopsSidebarTextPlan`,
    defaultMessage: `Plan`
  },
  devopsSidebarTextCode: {
    id: `${ID_PREFIX}devopsSidebarTextCode`,
    defaultMessage: `Code`
  },
  devopsSidebarTextDeploy: {
    id: `${ID_PREFIX}devopsSidebarTextDeploy`,
    defaultMessage: `Deploy`
  },
  devopsSidebarTextOperate: {
    id: `${ID_PREFIX}devopsSidebarTextOperate`,
    defaultMessage: `Operate`
  },
  devopsSidebarTextCollaborate: {
    id: `${ID_PREFIX}devopsSidebarTextCollaborate`,
    defaultMessage: `Collaborate`
  },
  errorTimeoutN2E: {
    id: `${ID_PREFIX}errorTimeout`,
    defaultMessage:
      '<span>It\'s taking longer than expected to get you started. Please <a href="/company/contact" track-link-ga="error-contact-us">contact us</a>.</span>'
  },
  errorTimeoutN2N: {
    id: `${ID_PREFIX}errorTimeout`,
    defaultMessage:
      '<span>It\'s taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <a href="/company/contact">contact us</a>.</span>'
  },
  provisioningTakesTime: {
    id: `${ID_PREFIX}provisioningTakesTime`,
    defaultMessage: 'Please wait a moment, this can take up to a minute...'
  },
  socialSignUpButtonContinueWithGoogle: {
    id: `${ID_PREFIX}socialSignUpButtonContinueWithGoogle`,
    defaultMessage: 'Continue with Google'
  },
  socialSignUpOr: {
    id: `${ID_PREFIX}socialSignUpOr`,
    defaultMessage: 'OR'
  },
  socialSignUpButtonSignUpWithEmail: {
    id: `${ID_PREFIX}socialSignUpButtonSignUpWithEmail`,
    defaultMessage: 'Sign up with email'
  },
  nextButton: {
    id: `${ID_PREFIX}nextButton`,
    defaultMessage: 'Next'
  },
  previousButton: {
    id: `${ID_PREFIX}previousButton`,
    defaultMessage: 'Prev'
  }
});
